import { render } from "./LoadAddress.vue?vue&type=template&id=1d2994e8&ts=true"
import script from "./LoadAddress.vue?vue&type=script&lang=ts"
export * from "./LoadAddress.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__